import { LegalPage } from '../components/LegalPage';

export default function CookiePolicyPage() {
  return (
    <LegalPage
      title="Cookie Policy"
      lastUpdated="30 marzo 2026"
      activePage="/cookie"
    >

      <div className="highlight-box">
        <p style={{ marginBottom: 0 }}>
          Il presente documento integra la <a href="/privacy">Privacy Policy</a> di Shangrilux e descrive in dettaglio le tipologie di cookie e tecnologie di tracciamento utilizzate dalla piattaforma, in conformità all'art. 122 del D.Lgs. 196/2003 e alle Linee Guida del Garante per la protezione dei dati personali (provvedimento del 10 giugno 2021).
        </p>
      </div>

      <h2>1. Cosa sono i Cookie</h2>
      <p>
        I cookie sono piccoli file di testo che i siti web visitati dall'utente inviano e registrano sul suo terminale (computer, smartphone, tablet), per essere poi ritrasmessi agli stessi siti ad ogni visita successiva. Grazie ai cookie, i siti web ricordano le azioni e le preferenze dell'utente nel tempo.
      </p>
      <p>
        Oltre ai cookie, possono essere utilizzate tecnologie analoghe come <strong>localStorage</strong>, <strong>sessionStorage</strong> e <strong>pixel di tracciamento</strong>. Il presente documento si riferisce a tutte queste tecnologie in modo collettivo con il termine "cookie".
      </p>

      <h2>2. Categorie di Cookie Utilizzati</h2>

      <h3>2.1 Cookie Tecnici / Necessari (senza consenso)</h3>
      <p>
        I cookie tecnici sono strettamente necessari al funzionamento del sito e della piattaforma e non richiedono il consenso dell'utente ai sensi del Provvedimento Garante 229/2014 e delle Linee Guida 2021.
      </p>
      <table>
        <thead>
          <tr>
            <th>Nome / Chiave</th>
            <th>Tipo</th>
            <th>Finalità</th>
            <th>Durata</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>ostivex_cookie_consent</code></td>
            <td>localStorage</td>
            <td>Memorizzazione delle preferenze cookie espresse dall'utente</td>
            <td>12 mesi</td>
          </tr>
          <tr>
            <td><code>lux_theme</code></td>
            <td>localStorage</td>
            <td>Memorizzazione della preferenza tema (scuro/chiaro) dell'interfaccia</td>
            <td>Persistente</td>
          </tr>
          <tr>
            <td>Token di sessione (JWT)</td>
            <td>Cookie HttpOnly / localStorage</td>
            <td>Autenticazione utente nella piattaforma admin</td>
            <td>Sessione / 7 giorni</td>
          </tr>
          <tr>
            <td>Cookie CSRF</td>
            <td>Cookie sicuro</td>
            <td>Protezione contro attacchi Cross-Site Request Forgery</td>
            <td>Sessione</td>
          </tr>
        </tbody>
      </table>

      <h3>2.2 Cookie Analitici (con consenso)</h3>
      <p>
        I cookie analitici ci permettono di capire come gli utenti interagiscono con il sito, raccogliendo informazioni in forma anonima o aggregata. Vengono attivati solo previo consenso esplicito dell'utente.
      </p>
      <table>
        <thead>
          <tr>
            <th>Fornitore</th>
            <th>Finalità</th>
            <th>Durata</th>
            <th>Privacy</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Analisi aggregata interna</td>
            <td>Statistiche anonime sulle visite alle pagine pubbliche (/, /pricing)</td>
            <td>30 giorni</td>
            <td>Nessun dato personale trasmesso a terzi</td>
          </tr>
        </tbody>
      </table>
      <p>
        <em>Nota: Shangrilux non utilizza attualmente Google Analytics o altri sistemi di analisi che trasmettono dati a terze parti. Le statistiche sono calcolate internamente su dati aggregati e anonimi.</em>
      </p>

      <h3>2.3 Cookie di Marketing / Profilazione (con consenso)</h3>
      <p>
        I cookie di marketing vengono utilizzati per mostrare annunci pubblicitari pertinenti agli interessi dell'utente. Attualmente, Shangrilux <strong>non utilizza cookie di profilazione propri</strong>. Nel caso in cui venissero introdotti in futuro, questa policy verrà aggiornata con almeno 15 giorni di preavviso agli utenti registrati.
      </p>

      <h2>3. Cookie di Terze Parti</h2>
      <p>
        Shangrilux può includere componenti provenienti da terze parti che potrebbero impostare cookie propri. In tali casi, la raccolta e l'uso delle informazioni da parte di tali terze parti sono regolate dalle rispettive privacy policy.
      </p>
      <table>
        <thead>
          <tr>
            <th>Terza Parte</th>
            <th>Finalità</th>
            <th>Consenso richiesto</th>
            <th>Link Policy</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Google Fonts</td>
            <td>Caricamento font tipografici (Cormorant Garamond, DM Sans)</td>
            <td>No (tecnico)</td>
            <td><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Google</a></td>
          </tr>
          <tr>
            <td>Stripe</td>
            <td>Elaborazione pagamenti (solo nelle pagine di checkout)</td>
            <td>No (necessario per contratto)</td>
            <td><a href="https://stripe.com/it/privacy" target="_blank" rel="noopener noreferrer">Privacy Stripe</a></td>
          </tr>
          <tr>
            <td>Unsplash</td>
            <td>Immagini stock (Open Graph image)</td>
            <td>No (tecnico)</td>
            <td><a href="https://unsplash.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Unsplash</a></td>
          </tr>
        </tbody>
      </table>

      <h2>4. Gestione delle Preferenze Cookie</h2>
      <p>
        Al primo accesso al sito, viene presentato un <strong>banner informativo</strong> che consente all'utente di:
      </p>
      <ul>
        <li>Accettare tutti i cookie (tecnici + analitici + marketing)</li>
        <li>Accettare solo i cookie strettamente necessari</li>
        <li>Personalizzare le preferenze categoria per categoria</li>
      </ul>
      <p>
        Le preferenze espresse vengono memorizzate nel localStorage del browser con la chiave <code>ostivex_cookie_consent</code> e possono essere modificate in qualsiasi momento.
      </p>

      <h3>4.1 Revocare il Consenso</h3>
      <p>Per revocare o modificare le preferenze cookie già espresse, è possibile:</p>
      <ul>
        <li>Cancellare i cookie e il localStorage dal browser (le impostazioni si trovano solitamente in Impostazioni → Privacy → Cookie)</li>
        <li>Contattare il Titolare a <a href="mailto:info@shangrilux.com">info@shangrilux.com</a> per una cancellazione manuale</li>
      </ul>

      <h3>4.2 Blocco dei Cookie tramite Browser</h3>
      <p>È possibile bloccare o limitare i cookie tramite le impostazioni del browser. Si tenga presente che il blocco dei cookie tecnici potrebbe compromettere il corretto funzionamento della piattaforma Shangrilux, in particolare le funzioni di autenticazione e gestione della sessione.</p>
      <p>Guide per la gestione dei cookie nei principali browser:</p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
      </ul>

      <h2>5. Do Not Track (DNT)</h2>
      <p>
        Shangrilux rispetta il segnale "Do Not Track" (DNT) inviato dal browser. Quando questo segnale è attivo, non vengono attivati cookie analitici o di marketing, indipendentemente dalle preferenze memorizzate.
      </p>

      <h2>6. Modifiche alla Cookie Policy</h2>
      <p>
        Il Titolare si riserva il diritto di modificare la presente Cookie Policy per adeguarla a eventuali cambiamenti tecnologici, normativi o del servizio. Le modifiche sostanziali vengono comunicate agli utenti con avviso in evidenza sul sito. La versione aggiornata è sempre disponibile alla URL <a href="/cookie">https://shangrilux.com/cookie</a>.
      </p>

    </LegalPage>
  );
}
